import { Divider, Flex } from '@chakra-ui/react';
import CompaniesService from 'api/services/CompaniesService';
import Dialog from 'components/Dialog';
import InputMy from 'components/InputMy';
import { useFormik } from 'formik';
import showMessage from 'providers/NoticeProvider/showMessage';
import { ReactElement, useState } from 'react';
import { createCompanyValidationSchema } from 'validations';

type TProps = {
    trigger: ReactElement;
};

const initialValues = {
    name: '',
    firstName: '',
    lastName: '',
    email: '',
};

const CreateCompanyDialog = ({ trigger }: TProps) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues,
        validationSchema: createCompanyValidationSchema,
        onSubmit: async params => {
            try {
                setLoading(true);
                await CompaniesService.create({
                    name: params.name,
                    user: {
                        firstName: params.firstName,
                        lastName: params.lastName,
                        email: params.email,
                    },
                })
                    .then(response => {
                        setOpen(false);
                        showMessage('Company successfuly created');
                        console.log('response', response);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } catch (e) {
                return false;
            }
        },
    });

    return (
        <Dialog
            forceIsOpen={open}
            setOpen={setOpen}
            loading={loading}
            trigger={trigger}
            title="Create company"
            submitText="Create"
            onSubmit={formik.submitForm}
            size="lg"
        >
            <Flex flexDirection="column" gap="24px">
                <InputMy
                    name="name"
                    label="Company name"
                    placeholder="Company name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                    onBlur={formik.handleBlur}
                />
                <Divider />
                <Flex gap="16px">
                    <InputMy
                        name="firstName"
                        label="User first name"
                        placeholder="User first name"
                        value={formik.values.firstName}
                        onChange={formik.handleChange}
                        error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                        helperText={formik.touched.firstName && formik.errors.firstName}
                        onBlur={formik.handleBlur}
                    />
                    <InputMy
                        name="lastName"
                        label="User last name"
                        placeholder="User last name"
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                        error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                        helperText={formik.touched.lastName && formik.errors.lastName}
                        onBlur={formik.handleBlur}
                    />
                </Flex>
                <InputMy
                    name="email"
                    label="User email"
                    placeholder="User email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                    onBlur={formik.handleBlur}
                />
            </Flex>
        </Dialog>
    );
};

export default CreateCompanyDialog;
